import { AxiosError } from 'axios';
import {
  IPullRequest,
  IPullRequestSearch,
  IPRStats,
  IPRStatsRequest,
} from 'interface/pullRequestInterface';
import { baseService } from 'services';
import { IErrorResponse, ISuccessResponse } from 'interface/apiInterface';

import {
  commonError,
  searchPullRequestEP,
  getPRStatsEP,
} from 'services/constants';

class PullRequestMockService {
  commonResponse = async <T = null>(
    data: T | null = null,
  ): Promise<ISuccessResponse<T> | IErrorResponse<AxiosError>> => {
    try {
      return await new Promise<ISuccessResponse>(resolve => {
        setTimeout(() => {
          resolve({
            data: data ?? null,
            status: 200,
            message: 'success',
          });
        }, 1000);
      });
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
  searchPullRequest = async () => {
    return this.commonResponse();
  };
  getPRStats = async () => {
    return this.commonResponse();
  };
}

class PullRequestService {
  searchPullRequest = async (
    searchParams: IPullRequestSearch,
  ): Promise<ISuccessResponse<IPullRequest[]> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(searchPullRequestEP, searchParams);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
  getPRStats = async (
    searchParams: IPRStatsRequest,
  ): Promise<ISuccessResponse<IPRStats> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(getPRStatsEP, searchParams);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
}

const pullRequestService: PullRequestService | PullRequestMockService =
  process.env.REACT_APP_MOCK_API === 'true'
    ? new PullRequestMockService()
    : new PullRequestService();

export default pullRequestService;
